export default "__VITE_ASSET__uzeLBdn3__"